export default {"src":"/login-app/[GIT_HASH]/_next/static/media/tune.4d5d83de.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};